"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@angular-redux/store");
var actions_1 = require("../../../core/actions");
var accessory_local_service_1 = require("../../../shared/service/accessory-local.service");
var accessory_amount_movement_1 = require("../../../shared/model/accessory-amount-movement");
var accessory_status_service_1 = require("../../service/accessory-status.service");
var toast_service_1 = require("../../../shared/service/toast.service");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var router_1 = require("@angular/router");
var user_roles_1 = require("../../../attending/constants/user-roles");
var AccessoryComponent = /** @class */ (function () {
    function AccessoryComponent(ngRedux, _accessoryLocalService, _accessoryStatusService, _toastService, _authService, _router) {
        this.ngRedux = ngRedux;
        this._accessoryLocalService = _accessoryLocalService;
        this._accessoryStatusService = _accessoryStatusService;
        this._toastService = _toastService;
        this._authService = _authService;
        this._router = _router;
        this.accessories = new Map();
        this.amountMovement = new Array();
        this.fixedSize = true;
        this.opened = '';
        this.isMovingAccessories = false;
        this.txOnMoveAccessory = new core_1.EventEmitter();
        this.txOnCancelMove = new core_1.EventEmitter();
        this.setUpObservers();
        this.findAccessoryStatus();
        this.setEmptyEntities();
    }
    AccessoryComponent.prototype.ngOnInit = function () {
        if (this.fixedSize === undefined) {
            this.fixedSize = true;
        }
    };
    AccessoryComponent.prototype.setEmptyEntities = function () {
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
    };
    AccessoryComponent.prototype.save = function () {
        if (this.canSave()) {
            this.isMovingAccessories = false;
            this.txOnMoveAccessory.emit(this.amountMovement);
        }
        else {
            this.showMessage('Mova todos os acessórios escolhidos corretamente.');
        }
    };
    AccessoryComponent.prototype.cancel = function () {
        this.stopMovingAccessories();
        this.txOnCancelMove.emit();
    };
    AccessoryComponent.prototype.addFreeAccessory = function (amount) {
        if (amount.quantity > 0) {
            this.ngRedux.dispatch({ type: actions_1.ADD_FREE_ACCESSORY, body: amount });
        }
    };
    AccessoryComponent.prototype.addToAmountMovement = function (event, amount, freeAccessory) {
        var assignedTotal = this.countTotalAssigned(freeAccessory);
        var stillFree = freeAccessory.quantity - assignedTotal;
        if (stillFree >= 0) {
            return event.target.valueAsNumber;
        }
        else {
            event.target.valueAsNumber -= 1;
            return event.target.valueAsNumber;
        }
    };
    AccessoryComponent.prototype.thereIsFreeAccessory = function (accessory) {
        var assignedTotal = this.countTotalAssigned(accessory);
        var stillFree = accessory.quantity - assignedTotal;
        return stillFree > 0;
    };
    AccessoryComponent.prototype.addAccessoryMovement = function (freeAccessory) {
        if (this.thereIsFreeAccessory(freeAccessory)) {
            var newAmount = new accessory_amount_movement_1.AccessoryAmountMovement();
            newAmount.accessoryId = freeAccessory.accessoryId;
            newAmount.quantity = 1;
            this.amountMovement.push(newAmount);
        }
    };
    AccessoryComponent.prototype.findLocalsToMove = function (name) {
        this._accessoryLocalService
            .findByNameIgnoreLocal(name, 0, 30, this.selectedLocal.id, this.selectedLocal.accessoryLocalType);
    };
    AccessoryComponent.prototype.getAccessoriesKeys = function () {
        if (this.accessories) {
            return Object.keys(this.accessories);
        }
        return [];
    };
    AccessoryComponent.prototype.getAmountQuantity = function (key) {
        var total = 0;
        this.accessories[key].forEach(function (amount) {
            total += amount.quantity;
        });
        return total;
    };
    AccessoryComponent.prototype.toggleOpenedAccessory = function (accessoryType) {
        if (this.opened === accessoryType) {
            this.opened = '';
        }
        else {
            this.opened = accessoryType;
        }
    };
    AccessoryComponent.prototype.moveAccessories = function () {
        if (this.ngRedux.getState().freeAccessoriesTotal > 0) {
            this.isMovingAccessories = true;
            this.opened = '';
        }
    };
    AccessoryComponent.prototype.stopMovingAccessories = function () {
        this.isMovingAccessories = false;
        this.opened = '';
    };
    AccessoryComponent.prototype.getMaxAccessories = function (totalQuantity, accessoryId) {
        var assignedTotal = 0;
        for (var _i = 0, _a = this.amountMovement; _i < _a.length; _i++) {
            var amount = _a[_i];
            if (amount.accessoryId === accessoryId) {
                assignedTotal += amount.quantity;
            }
        }
        return totalQuantity - assignedTotal;
    };
    AccessoryComponent.prototype.canCreateAccessory = function () {
        if (this.authenticatedUser.role === user_roles_1.UserRoles.ESTOQUE || this.authenticatedUser.role === user_roles_1.UserRoles.ADMIN) {
            return true;
        }
    };
    AccessoryComponent.prototype.newAccessory = function () {
        this._router.navigate(['accessories/new']);
    };
    AccessoryComponent.prototype.canSave = function () {
        var totalAvailable = this.ngRedux.getState().freeAccessoriesTotal;
        var totalAssigned = this.setAmountAttributes();
        return totalAssigned === totalAvailable;
    };
    AccessoryComponent.prototype.setAmountAttributes = function () {
        var totalAssigned = 0;
        for (var _i = 0, _a = this.amountMovement; _i < _a.length; _i++) {
            var amount = _a[_i];
            if (amount.accessoryStatus) {
                amount.accessoryStatusId = amount.accessoryStatus.id;
            }
            else {
                return 0;
            }
            amount.localId = amount.local.id;
            amount.localType = amount.local.accessoryLocalType;
            totalAssigned += amount.quantity;
        }
        return totalAssigned;
    };
    AccessoryComponent.prototype.findAccessoryStatus = function () {
        var _this = this;
        this._accessoryStatusService.findAll()
            .subscribe(function (status) { return _this.accessoryStatus = status; }, function (error) { return _this.showMessage(error); });
    };
    AccessoryComponent.prototype.countTotalAssigned = function (freeAccessory) {
        var assignedTotal = 0;
        for (var _i = 0, _a = this.amountMovement; _i < _a.length; _i++) {
            var currentAmount = _a[_i];
            if (currentAmount.accessoryId === freeAccessory.accessoryId) {
                assignedTotal += currentAmount.quantity;
            }
        }
        return assignedTotal;
    };
    AccessoryComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._accessoryLocalService.findLocalToMove$
            .subscribe(function (localsToMove) { return _this.localsToMove = localsToMove; });
    };
    AccessoryComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    AccessoryComponent.ctorParameters = function () { return [{ type: store_1.NgRedux }, { type: accessory_local_service_1.AccessoryLocalService }, { type: accessory_status_service_1.AccessoryStatusService }, { type: toast_service_1.ToastService }, { type: authentication_service_1.AuthenticationService }, { type: router_1.Router }]; };
    __decorate([
        store_1.select('freeAccessoriesTotal'),
        __metadata("design:type", Object)
    ], AccessoryComponent.prototype, "freeAccessoriesTotal$", void 0);
    __decorate([
        store_1.select('freeAccessories'),
        __metadata("design:type", Object)
    ], AccessoryComponent.prototype, "freeAccessories$", void 0);
    return AccessoryComponent;
}());
exports.AccessoryComponent = AccessoryComponent;
//# sourceMappingURL=accessory.component.js.map


// WEBPACK FOOTER //
// accessory.component.js